module.exports = __webpack_public_path__ + "img/avatar.67c57489.png";